// @flow
import PayWithCheckContainer from './PayWithCheckContainer'

export default PayWithCheckContainer
